export const API_DIRECTORY = {
  //DOC_ROOT: "https://api.coindesk.com/v1/bpi/currentprice.json"
  DOC_ROOT: "https://dashboard-test.tvunetworks.com/dashboardservice-backend/gridMap/getGridDataByGeoLocation",
  HISTORY_LOG_API:"https://dashboard-test.tvunetworks.com/dashboardservice-backend/openapi/v3.0/gridReport/liveDetail",
  GETCURRENTTIME_API:"https://cc-ms.tvunetworks.com/ccp/tvucc-access/accessApp/getTime"
};
export const urlConstants = {
  BASEURL: API_DIRECTORY.DOC_ROOT,
  HISTORYLOGAPI : API_DIRECTORY.HISTORY_LOG_API,
  GETCURRENTTIMEAPI : API_DIRECTORY.GETCURRENTTIME_API
};


// WEBPACK FOOTER //
// ./src/constants/uri.constants.js